import { getAxiosInstance } from '../../../np-rest/rest';
import * as actionTypes from '../../../np-core/Auth/store/actionTypes';
import restCrudActions from '../../../np-crud/store/restCrudActions';
import { snackActions } from '../../../sc-utilities/SnackBar';

const crudActions = restCrudActions({
    endpointBasePath: 'users',
    pluginName: 'ACTIVE_CUSTOMER',
    entityName: 'ACTIVE_CUSTOMER',
    fetchSuccessMessage: '',
    loadSuccessMessage: ''
});

const setActiveCustomerStart = () => {
    return {
        type: actionTypes.CORE_SET_ACTIVE_CUSTOMER_START
    };
};

const setActiveCustomerSuccess = result => {
    return {
        type: actionTypes.CORE_SET_ACTIVE_CUSTOMER_SUCCESS,
        activeCustomer: result.customer,
        permissions: result.permissions,
        activeExternalServiceAvailable: result.activeExternalServiceAvailable
    };
};

const setActiveCustomerFail = error => {
    return {
        type: actionTypes.CORE_SET_ACTIVE_CUSTOMER_FAIL,
        error: error
    };
};

// Fetch Pendrive action creators
export const changeActiveCustomer = customerID => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(setActiveCustomerStart());
        try {
            const data = { ActiveCustomerID: customerID, CustomerID: customerID };
            let res = await rest.post('/users/set_active_customer/', data);
            if (res.data.succeeded) {
                const result = res.data.result.data;
                dispatch(setActiveCustomerSuccess(result));
                window.top.location = '/login';
            } else {
                dispatch(setActiveCustomerFail(res.error));
            }
        } catch (err) {
            dispatch(setActiveCustomerFail(err));
        }
    };
};

// Fetch customers action creators
export const fetchCustomersInit = () => {
    return crudActions.fetchInit();
};
export const fetchCustomersStart = () => {
    return crudActions.fetchStart();
};
export const fetchCustomersSuccess = (count, list) => {
    return crudActions.fetchSuccess(count, list);
};
export const fetchCustomersFail = () => {
    return crudActions.fetchFail();
};
export const fetchCustomersCount = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchCustomersStart());
        try {
            let countRes = await rest.post("users/count_associated_customers", filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchCustomersSuccess(0, []));
                }
                return countRes.data.result.data
            }
            dispatch(fetchCustomersFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch customers."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            dispatch(fetchCustomersFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch customers."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}

export const fetchCustomers = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchCustomersStart());
        try {
            let listRes = await rest.post("users/list_associated_customers", filterData);
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchCustomersSuccess(filterData.count, listRes.data.result.data));
                return listRes.data.result.data.Customers
            }
            dispatch(fetchCustomersFail());
            return []

        } catch (error) {
            dispatch(fetchCustomersFail());
            return []
        }
    }
}